import styled from 'styled-components';

const ResultsContainer = styled.div`
  max-width: 1000px;
  margin: 0 auto;
  padding: 2rem 1rem;
`;

const PageTitle = styled.h1`
  margin: 0 0 2rem 0;
  font-size: 2.5rem;
  font-weight: bold;
`;

const ResultCard = styled.div`
  background-color: white;
  border-radius: 8px;
  padding: 1.5rem;
  margin-bottom: 1rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  
  .match-header {
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    gap: 2rem;
    align-items: center;
    margin-bottom: 1.5rem;
    
    .team {
      text-align: center;
      
      .logo-container {
        margin-bottom: 0.5rem;
        display: flex;
        justify-content: center;
      }
    }
    
    .score {
      font-size: 2rem;
      font-weight: bold;
      color: var(--primary);
    }
  }
  
  .match-details {
    border-top: 1px solid #eee;
    padding-top: 1rem;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 1rem;
    
    .detail {
      text-align: center;
      
      h4 {
        color: var(--gray);
        margin-bottom: 0.5rem;
      }
    }
  }
`;

const LoadingState = styled.div`
  text-align: center;
  padding: 2rem;
  color: var(--gray);
`;

const ErrorState = styled.div`
  text-align: center;
  padding: 2rem;
  color: var(--gray);
  background: white;
  border-radius: 8px;
  margin-top: 1rem;
`;

export { ResultsContainer, LoadingState, ErrorState, ResultCard, PageTitle };